<template>
  <div class="row col-11 mx-auto">
    <div class="col">
      <section class="p-2 col-md-8 mx-auto">
        <h2 class="text-center my-4">Главная страница</h2>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Home.vue